export const POPUP_CONFIG = 'height=300, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';
export const REDIRECT_SHARE_URL = '/sharing/social_redirect';

export const platforms = {
    FACEBOOK: 'facebook',
    WHATSAPP: 'whatsapp',
    FB_MESSANGER: 'fb_messanger',
    TWITTER: 'twitter',
    EMAIL: 'email',
    LINKEDIN: 'linkedin',
    COPY_LINK: 'copy_link',
    EMBED: 'embed'
};



// WEBPACK FOOTER //
// ./src/utils/constants.js